import { TextLink } from '@cint/wonderment';
import { MdKeyboardArrowLeft } from 'react-icons/md';

export interface BackButtonProps {
  href: string;
  linkName: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const BackButton = ({ href, linkName, onClick }: BackButtonProps) => (
  <div className="flex items-center mb-4">
    <MdKeyboardArrowLeft size={24} className="ds-text-action" />
    <TextLink
      label={linkName}
      href={href}
      variant="link"
      size="sm"
      fontWeight="medium"
      className="ds-no-underline hover:ds-no-underline"
      onClick={onClick}
    />
  </div>
);
